/** Please don't modify or unzip this content. It will be updated regularly **/
    (function() {
      BoostPFS.inject(this);

      //Set global variable
      Globals.hasIntegration = true;
      // 3rd app compile template
      Integration.compileIntegrationTemplate = function (data, itemHtml) {
        var sswReviewsHtml = `<div class="gw-rv-listing-average-placeholder" data-gw-product-id="${data.id}" style="display: block"></div>`;
        
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, sswReviewsHtml);
        return itemHtml;
      };

      Integration.call3rdIntegrationFunc = function(data) {}
    })();